const CryptoJS = require('../../../node_modules/crypto-js/crypto-js');
// Import configs file
const config = require('../../../config');
// Import moment
var moment = require('moment');
//Import signaturePad
require('../libs/jquery.signaturepad.min.js');

/*global google:true*/

/**
 * Fetch param value in URL of page
 * @returns {boolean} Value of param
 */
function getParamValue(param){
	let value = null;
	let searchParams = new URLSearchParams(window.location.search);

	if (searchParams.has(param)) {
		value = searchParams.get(param);
	}
	
	return value;
}

/**
 * Remove url param from url
 * @param {string} url
 * @param {string} param
 * @returns {string} new url without param
 */
function removeURLParameter(url, parameter) {
	//prefer to use l.search if you have a location/link object
	var urlparts= url.split('?');

	if (urlparts.length>=2) {
		var prefix= encodeURIComponent(parameter)+'=';
		var pars= urlparts[1].split(/[&;]/g);

		//reverse iteration as may be destructive
		for (var i= pars.length; i-- > 0;) {
			//idiom for string.startsWith
			if (pars[i].lastIndexOf(prefix, 0) !== -1) {
				pars.splice(i, 1);
			}
		}
		url= urlparts[0]+'?'+pars.join('&');
		return url;
	} else {
		return url;
	}

}

/**
 * Serialize form functions
 * @param {Object} form
 * @returns {Object} Serialized object
 */
function getSerializeForm(form) {
	return form.serializeArray().reduce(function(obj, item) {

		if (obj[item.name] != undefined) {

			if (Array.isArray(obj[item.name])) {
				obj[item.name].push(item.value);
			}else{
				var tmp = obj[item.name];
				obj[item.name] = [];
				obj[item.name].push(tmp);
				obj[item.name].push(item.value);
			}

		} else {
			obj[item.name] = item.value;
		}

		return obj;

	}, {});
}

/**
 * Initialize Google Map
 */
function initMap() {
	var clinic_lat = $(document).find('input[name="lat"]').val();
	var clinic_lng = $(document).find('input[name="lng"]').val();

	if (clinic_lat && clinic_lng) {
		// Init the map with the user geolocalisation
		var latlngcenter = new google.maps.LatLng(clinic_lat, clinic_lng);
		var myOptions = {
			zoom: 16,
			center: latlngcenter,
			disableDefaultUI: true,
			zoomControl: true,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.SMALL
			},
			scrollwheel:false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: config.vars.mapStyle
		};
		var pin_doctor   = '/microsite/images/pin.png';
		var map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);
		var clinique_lat = clinic_lat;
		var clinique_lng = clinic_lng;
		new google.maps.Marker({
			map: map,
			position: new google.maps.LatLng(clinique_lat, clinique_lng),
			icon:{
				url: pin_doctor, // url
				scaledSize: new google.maps.Size(30, 41), // scaled size
				origin: new google.maps.Point(0,0), // origin
				anchor: new google.maps.Point(15, 41) // anchor
			}
		});
	}

}

/**
 * Init datepicker
 */
function initDatepicker() {
	$('.datepicker').each(function() {
		var config = {
			changeYear: true,
			autoclose: true,
			keyboardNavigation: true,
			language: 'fr',
			changeMonth: true,
			dateFormat: 'dd/mm/yy',
			todayHighlight: true,
			gotoCurrent: true
		};
		$(this).datepicker(config);
	});
}

/**
 * Init datepicker year
 */
function initDatepickerYear() {
	$('.datepicker-year').each(function() {
		var config = {
			format: 'yyyy',
			viewMode: 'years', 
			minViewMode: 'years',
			keyboardNavigation: true,
			autoclose: true,
			todayHighlight: true,
			endDate: new Date()
		};
		$(this).datepicker(config);
	});
}

/**
 * Init Signature Pad
 */
function initSignaturePad() {

	if ($('.sigPad').length) {
		$(document).find('.sigPad').signaturePad({
			drawOnly :true,
			lineWidth : 0,
			validateFields :true,
			errorMessageDraw : $(document).find('.error-signature').text()
		});
	}

}

/**
 * Compute signature
 * @returns {string} The base64 representation of the payload hash
 */
function getSignature(url, payload){
	const sortedPayload = Object.keys(payload).sort();

	for (const prop of sortedPayload) {
		url += prop + payload[prop];
	}

	const sha1 = CryptoJS.SHA1(url);
	return sha1.toString(CryptoJS.enc.Base64);
}

/**
 * Process phone validation
 * @param {Object} event jQuery event
 */
function processPhoneValidation(event, phoneInput, info){
	event.preventDefault();
	const isValid = phoneInput.isValidNumber();

	if (!isValid) {
		info.text('Votre numéro de téléphone n\'est pas valide').removeClass('alert-primary').addClass('alert-danger').removeClass('d-none');
		setTimeout(function() {
			info.addClass('d-none');
		},5000);
		return false;
	} else {
		info.addClass('d-none');
	}

	return true;
}

/**
 * checkScroll to detect window scroll
 */
function checkScroll() {
	$(document).on('scroll', function(){

		if($(document).scrollTop() > $(document).find('header nav.fixed-top').outerHeight()){
			$( 'html' ).addClass('header-min');
		}else{
			$( 'html' ).removeClass('header-min');
		}

	});
}

/**
 * Initialize Google Map
 */
function initColor(clinic) {
	let defaultService = clinic.defaultService;
	let allServices = clinic.allServices;
	let primary_color = '';
	let secondary_color = '';
	allServices.forEach(service => {
		if (service.id == defaultService) {
			primary_color = service.primary;
			secondary_color = service.secondary;
		}
	});

	if (primary_color && secondary_color) {
		$('html').css('--primary-color', primary_color);
		$('html').css('--secondary-color', secondary_color);
	}

}

/**
 * Validate email field
 * @param {String} email Email
 * @returns {boolean}
 */
function isEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}

/**
 * Check if date is valid
 * @param {String} str 
 * @param {String} format 
 * @returns {boolean}
 */
function isValidDate(str, format) {
	var format_date = (format != '') ? format : 'D/M/YYYY';
	var d = moment(str,format_date);

	if (d == null || !d.isValid()) return false;

	return str.indexOf(d.format('D/M/YYYY')) >= 0 
			|| str.indexOf(d.format('DD/MM/YYYY')) >= 0
			|| str.indexOf(d.format('D/M/YY')) >= 0 
			|| str.indexOf(d.format('DD/MM/YY')) >= 0
			|| str.indexOf(d.format('M/YYYY')) >= 0;
}

/**
 * Check cookies param
 */
function checkCookies() {
	if ($.cookie('qm-success')) {
		$('.notifications-section').find('div[data-type="qm-success"]').removeClass('hide');
		$('.notifications-section').attr('data-state', 1);
		$.removeCookie('qm-success');
	} else if ($.cookie('qm-error')) {
		$('.notifications-section').find('div[data-type="qm-error"]').removeClass('hide');
		$('.notifications-section').attr('data-state', 1);
		$.removeCookie('qm-error');
	}
}

/**
 * Check if the microsite was opened on PWA mode
 */
function isInStandaloneMode() {
	if((window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://'))
		$('#btnBackToBucco').show();
	else $('#btnBackToBucco').hide();
}

module.exports = {
	getSerializeForm,
	getParamValue,
	getSignature,
	processPhoneValidation,
	removeURLParameter,
	isEmail,
	initMap,
	initDatepicker,
	initDatepickerYear,
	initColor,
	checkScroll,
	initSignaturePad,
	checkCookies,
	isValidDate,
	isInStandaloneMode
};
